import { createSlice } from "@reduxjs/toolkit";
import { endorsementsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const endorsementsSlice = createSlice({
  name: "endorsements",
  initialState: data,
  reducers: {
    endorsementsSlice(state) {
      state.isLoading = false;
    },
    endorsementsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    endorsementsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    endorsementsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const endorsementsHandler = () => async (dispatch: any) => {
  try {
    dispatch(endorsementsAction.endorsementsSlice());
    const response: any = await endorsementsAPI();
    dispatch(endorsementsAction.endorsementsSliceSuccess(response));
  } catch (e: any) {
    dispatch(endorsementsAction.endorsementsSliceFailure(e?.response?.data?.message));
    dispatch(endorsementsAction.endorsementsSliceReset());
  }
};
export default endorsementsSlice.reducer;
export const endorsementsAction = endorsementsSlice.actions;
